import { t as UsageQuotaService } from "./usage_quota_service-Dyfcck0l.mjs";
import { Injectable, createInterfaceId } from "@gitlab/needle";
import { gql } from "graphql-request";
import { EventEmitterImpl, GitLabApiService, RepositoryProvider, diffEmitter, isFetchError, isNot4xxFailure } from "@gitlab-org/core";
import { SELECTED_AGENT_PLATFORM_PROJECT_STORAGE_KEY, UserPersistentStorage } from "@gitlab-org/persistent-storage";
import { Logger, withPrefix } from "@gitlab-org/logging";
import { AbortError, isNotAbort, retry } from "@gitlab-org/resiliency";
import { InvalidInstanceVersionError } from "@gitlab-org/fetch";
//#region src/agent_platform_project_store.ts
let _initClass$2;
function _applyDecs$2(e, t, n, r, o, i) {
	var a, c, u, s, f, l, p, d = Symbol.metadata || Symbol.for("Symbol.metadata"), m = Object.defineProperty, h = Object.create, y = [h(null), h(null)], v = t.length;
	function g(t, n, r) {
		return function(o, i) {
			n && (i = o, o = e);
			for (var a = 0; a < t.length; a++) i = t[a].apply(o, r ? [i] : []);
			return r ? i : o;
		};
	}
	function b(e, t, n, r) {
		if ("function" != typeof e && (r || void 0 !== e)) throw new TypeError(t + " must " + (n || "be") + " a function" + (r ? "" : " or undefined"));
		return e;
	}
	function applyDec(e, t, n, r, o, i, u, s, f, l, p) {
		function d(e) {
			if (!p(e)) throw new TypeError("Attempted to access private element on non-instance");
		}
		var h = [].concat(t[0]), v = t[3], w = !u, D = 1 === o, S = 3 === o, j = 4 === o, E = 2 === o;
		function I(t, n, r) {
			return function(o, i) {
				return n && (i = o, o = e), r && r(o), P[t].call(o, i);
			};
		}
		if (!w) {
			var P = {}, k = [], F = S ? "get" : j || D ? "set" : "value";
			if (f ? (l || D ? P = {
				get: _setFunctionName$2(function() {
					return v(this);
				}, r, "get"),
				set: function(e) {
					t[4](this, e);
				}
			} : P[F] = v, l || _setFunctionName$2(P[F], r, E ? "" : F)) : l || (P = Object.getOwnPropertyDescriptor(e, r)), !l && !f) {
				if ((c = y[+s][r]) && 7 !== (c ^ o)) throw Error("Decorating two elements with the same name (" + P[F].name + ") is not supported yet");
				y[+s][r] = o < 3 ? 1 : o;
			}
		}
		for (var N = e, O = h.length - 1; O >= 0; O -= n ? 2 : 1) {
			var T = b(h[O], "A decorator", "be", !0), z = n ? h[O - 1] : void 0, A = {}, H = {
				kind: [
					"field",
					"accessor",
					"method",
					"getter",
					"setter",
					"class"
				][o],
				name: r,
				metadata: a,
				addInitializer: function(e, t) {
					if (e.v) throw new TypeError("attempted to call addInitializer after decoration was finished");
					b(t, "An initializer", "be", !0), i.push(t);
				}.bind(null, A)
			};
			if (w) c = T.call(z, N, H), A.v = 1, b(c, "class decorators", "return") && (N = c);
			else if (H.static = s, H.private = f, c = H.access = { has: f ? p.bind() : function(e) {
				return r in e;
			} }, j || (c.get = f ? E ? function(e) {
				return d(e), P.value;
			} : I("get", 0, d) : function(e) {
				return e[r];
			}), E || S || (c.set = f ? I("set", 0, d) : function(e, t) {
				e[r] = t;
			}), N = T.call(z, D ? {
				get: P.get,
				set: P.set
			} : P[F], H), A.v = 1, D) {
				if ("object" == typeof N && N) (c = b(N.get, "accessor.get")) && (P.get = c), (c = b(N.set, "accessor.set")) && (P.set = c), (c = b(N.init, "accessor.init")) && k.unshift(c);
				else if (void 0 !== N) throw new TypeError("accessor decorators must return an object with get, set, or init properties or undefined");
			} else b(N, (l ? "field" : "method") + " decorators", "return") && (l ? k.unshift(N) : P[F] = N);
		}
		return o < 2 && u.push(g(k, s, 1), g(i, s, 0)), l || w || (f ? D ? u.splice(-1, 0, I("get", s), I("set", s)) : u.push(E ? P[F] : b.call.bind(P[F])) : m(e, r, P)), N;
	}
	function w(e) {
		return m(e, d, {
			configurable: !0,
			enumerable: !0,
			value: a
		});
	}
	return void 0 !== i && (a = i[d]), a = h(null == a ? null : a), f = [], l = function(e) {
		e && f.push(g(e));
	}, p = function(t, r) {
		for (var i = 0; i < n.length; i++) {
			var a = n[i], c = a[1], l = 7 & c;
			if ((8 & c) == t && !l == r) {
				var p = a[2], d = !!a[3], m = 16 & c;
				applyDec(t ? e : e.prototype, a, m, d ? "#" + p : _toPropertyKey$2(p), l, l < 2 ? [] : t ? s = s || [] : u = u || [], f, !!t, d, r, t && d ? function(t) {
					return _checkInRHS$2(t) === e;
				} : o);
			}
		}
	}, p(8, 0), p(0, 0), p(8, 1), p(0, 1), l(u), l(s), c = f, v || w(e), {
		e: c,
		get c() {
			var n = [];
			return v && [w(e = applyDec(e, [t], r, e.name, 5, n)), g(n, 1)];
		}
	};
}
function _toPropertyKey$2(t) {
	var i = _toPrimitive$2(t, "string");
	return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$2(t, r) {
	if ("object" != typeof t || !t) return t;
	var e = t[Symbol.toPrimitive];
	if (void 0 !== e) {
		var i = e.call(t, r || "default");
		if ("object" != typeof i) return i;
		throw new TypeError("@@toPrimitive must return a primitive value.");
	}
	return ("string" === r ? String : Number)(t);
}
function _setFunctionName$2(e, t, n) {
	"symbol" == typeof t && (t = (t = t.description) ? "[" + t + "]" : "");
	try {
		Object.defineProperty(e, "name", {
			configurable: !0,
			value: n ? n + " " + t : t
		});
	} catch (e) {}
	return e;
}
function _checkInRHS$2(e) {
	if (Object(e) !== e) throw TypeError("right-hand side of 'in' should be an object, got " + (null !== e ? typeof e : "null"));
	return e;
}
const AgentPlatformProjectStore = createInterfaceId("AgentPlatformProjectStore");
let _DefaultAgentPlatform$1;
(class {
	static {
		[_DefaultAgentPlatform$1, _initClass$2] = _applyDecs$2(this, [Injectable(AgentPlatformProjectStore, [UserPersistentStorage, Logger])], []).c;
	}
	#storage;
	#logger;
	#eventEmitter = diffEmitter(new EventEmitterImpl());
	constructor(storage, logger) {
		this.#storage = storage;
		this.#logger = withPrefix(logger, "[AgentPlatformProjectStore]");
	}
	async setSelectedProject(repositoryPath, namespaceWithPath) {
		try {
			const allProjects = await this.getAllSelectedProjects();
			allProjects[repositoryPath] = namespaceWithPath;
			await this.#storage.set(SELECTED_AGENT_PLATFORM_PROJECT_STORAGE_KEY, allProjects);
			this.#eventEmitter.fire(allProjects);
			this.#logger.debug(`Set selected project for ${repositoryPath}: ${namespaceWithPath}`);
		} catch (error) {
			this.#logger.error("Failed to set selected Agentic Chat project", error);
			throw error;
		}
	}
	async getSelectedProject(repositoryPath) {
		try {
			return (await this.getAllSelectedProjects())[repositoryPath] || null;
		} catch (error) {
			this.#logger.error("Failed to get selected Agentic Chat project", error);
			return null;
		}
	}
	async clearSelectedProject(repositoryPath) {
		try {
			const allProjects = await this.getAllSelectedProjects();
			delete allProjects[repositoryPath];
			await this.#storage.set(SELECTED_AGENT_PLATFORM_PROJECT_STORAGE_KEY, allProjects);
			this.#eventEmitter.fire(allProjects);
			this.#logger.debug(`Cleared selected project for ${repositoryPath}`);
		} catch (error) {
			this.#logger.error("Failed to clear selected Agentic Chat project", error);
			throw error;
		}
	}
	async getAllSelectedProjects() {
		try {
			return await this.#storage.get(SELECTED_AGENT_PLATFORM_PROJECT_STORAGE_KEY) || {};
		} catch (error) {
			this.#logger.error("Failed to get all selected projects", error);
			return {};
		}
	}
	onSelectedProjectChange = this.#eventEmitter.event;
	static {
		_initClass$2();
	}
});
//#endregion
//#region src/agent_platform_project_service.ts
let _initClass$1;
function _applyDecs$1(e, t, n, r, o, i) {
	var a, c, u, s, f, l, p, d = Symbol.metadata || Symbol.for("Symbol.metadata"), m = Object.defineProperty, h = Object.create, y = [h(null), h(null)], v = t.length;
	function g(t, n, r) {
		return function(o, i) {
			n && (i = o, o = e);
			for (var a = 0; a < t.length; a++) i = t[a].apply(o, r ? [i] : []);
			return r ? i : o;
		};
	}
	function b(e, t, n, r) {
		if ("function" != typeof e && (r || void 0 !== e)) throw new TypeError(t + " must " + (n || "be") + " a function" + (r ? "" : " or undefined"));
		return e;
	}
	function applyDec(e, t, n, r, o, i, u, s, f, l, p) {
		function d(e) {
			if (!p(e)) throw new TypeError("Attempted to access private element on non-instance");
		}
		var h = [].concat(t[0]), v = t[3], w = !u, D = 1 === o, S = 3 === o, j = 4 === o, E = 2 === o;
		function I(t, n, r) {
			return function(o, i) {
				return n && (i = o, o = e), r && r(o), P[t].call(o, i);
			};
		}
		if (!w) {
			var P = {}, k = [], F = S ? "get" : j || D ? "set" : "value";
			if (f ? (l || D ? P = {
				get: _setFunctionName$1(function() {
					return v(this);
				}, r, "get"),
				set: function(e) {
					t[4](this, e);
				}
			} : P[F] = v, l || _setFunctionName$1(P[F], r, E ? "" : F)) : l || (P = Object.getOwnPropertyDescriptor(e, r)), !l && !f) {
				if ((c = y[+s][r]) && 7 !== (c ^ o)) throw Error("Decorating two elements with the same name (" + P[F].name + ") is not supported yet");
				y[+s][r] = o < 3 ? 1 : o;
			}
		}
		for (var N = e, O = h.length - 1; O >= 0; O -= n ? 2 : 1) {
			var T = b(h[O], "A decorator", "be", !0), z = n ? h[O - 1] : void 0, A = {}, H = {
				kind: [
					"field",
					"accessor",
					"method",
					"getter",
					"setter",
					"class"
				][o],
				name: r,
				metadata: a,
				addInitializer: function(e, t) {
					if (e.v) throw new TypeError("attempted to call addInitializer after decoration was finished");
					b(t, "An initializer", "be", !0), i.push(t);
				}.bind(null, A)
			};
			if (w) c = T.call(z, N, H), A.v = 1, b(c, "class decorators", "return") && (N = c);
			else if (H.static = s, H.private = f, c = H.access = { has: f ? p.bind() : function(e) {
				return r in e;
			} }, j || (c.get = f ? E ? function(e) {
				return d(e), P.value;
			} : I("get", 0, d) : function(e) {
				return e[r];
			}), E || S || (c.set = f ? I("set", 0, d) : function(e, t) {
				e[r] = t;
			}), N = T.call(z, D ? {
				get: P.get,
				set: P.set
			} : P[F], H), A.v = 1, D) {
				if ("object" == typeof N && N) (c = b(N.get, "accessor.get")) && (P.get = c), (c = b(N.set, "accessor.set")) && (P.set = c), (c = b(N.init, "accessor.init")) && k.unshift(c);
				else if (void 0 !== N) throw new TypeError("accessor decorators must return an object with get, set, or init properties or undefined");
			} else b(N, (l ? "field" : "method") + " decorators", "return") && (l ? k.unshift(N) : P[F] = N);
		}
		return o < 2 && u.push(g(k, s, 1), g(i, s, 0)), l || w || (f ? D ? u.splice(-1, 0, I("get", s), I("set", s)) : u.push(E ? P[F] : b.call.bind(P[F])) : m(e, r, P)), N;
	}
	function w(e) {
		return m(e, d, {
			configurable: !0,
			enumerable: !0,
			value: a
		});
	}
	return void 0 !== i && (a = i[d]), a = h(null == a ? null : a), f = [], l = function(e) {
		e && f.push(g(e));
	}, p = function(t, r) {
		for (var i = 0; i < n.length; i++) {
			var a = n[i], c = a[1], l = 7 & c;
			if ((8 & c) == t && !l == r) {
				var p = a[2], d = !!a[3], m = 16 & c;
				applyDec(t ? e : e.prototype, a, m, d ? "#" + p : _toPropertyKey$1(p), l, l < 2 ? [] : t ? s = s || [] : u = u || [], f, !!t, d, r, t && d ? function(t) {
					return _checkInRHS$1(t) === e;
				} : o);
			}
		}
	}, p(8, 0), p(0, 0), p(8, 1), p(0, 1), l(u), l(s), c = f, v || w(e), {
		e: c,
		get c() {
			var n = [];
			return v && [w(e = applyDec(e, [t], r, e.name, 5, n)), g(n, 1)];
		}
	};
}
function _toPropertyKey$1(t) {
	var i = _toPrimitive$1(t, "string");
	return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$1(t, r) {
	if ("object" != typeof t || !t) return t;
	var e = t[Symbol.toPrimitive];
	if (void 0 !== e) {
		var i = e.call(t, r || "default");
		if ("object" != typeof i) return i;
		throw new TypeError("@@toPrimitive must return a primitive value.");
	}
	return ("string" === r ? String : Number)(t);
}
function _setFunctionName$1(e, t, n) {
	"symbol" == typeof t && (t = (t = t.description) ? "[" + t + "]" : "");
	try {
		Object.defineProperty(e, "name", {
			configurable: !0,
			value: n ? n + " " + t : t
		});
	} catch (e) {}
	return e;
}
function _checkInRHS$1(e) {
	if (Object(e) !== e) throw TypeError("right-hand side of 'in' should be an object, got " + (null !== e ? typeof e : "null"));
	return e;
}
/**
* Service to access workspace repositories with their Agent Platform projects
*/
const AgentPlatformProjectService = createInterfaceId("AgentPlatformProjectService");
let _DefaultAgentPlatform;
(class {
	static {
		[_DefaultAgentPlatform, _initClass$1] = _applyDecs$1(this, [Injectable(AgentPlatformProjectService, [
			RepositoryProvider,
			AgentPlatformProjectStore,
			GitLabApiService,
			Logger
		])], []).c;
	}
	#repositoryProvider;
	#selectedProjectStore;
	#api;
	#logger;
	#eventEmitter = diffEmitter(new EventEmitterImpl());
	#repositoryProviderDisposable = null;
	constructor(repositoryProvider, selectedProjectStore, api, logger) {
		this.#repositoryProvider = repositoryProvider;
		this.#selectedProjectStore = selectedProjectStore;
		this.#api = api;
		this.#logger = withPrefix(logger, "[AgentPlatformProjectService]");
		this.#repositoryProviderDisposable = this.#repositoryProvider.onRepositoriesChange(() => this.#notifyRepositoriesChanged());
	}
	async #notifyRepositoriesChanged() {
		try {
			const repositories = await this.getRepositories();
			this.#eventEmitter.fire(repositories);
		} catch (error) {
			this.#logger.error(`Error notifying repositories changed: ${String(error)}`);
		}
	}
	onRepositoriesChange = this.#eventEmitter.event;
	async getRepositories() {
		const repositories = this.#repositoryProvider.getRepositories();
		this.#logger.debug(`Got ${repositories.repositories.length} repositories ${JSON.stringify(repositories, null, 2)}`);
		const enrichedRepositories = await Promise.all(repositories.repositories.filter((repo) => repo.type !== "none").map(async (repo) => {
			this.#logger.debug(`Checking DAP availability for ${repo.projects?.length || 0} projects in ${repo.repository.folderName}`);
			const enrichedProjects = await Promise.all((repo.projects || []).map(async (project) => {
				const { duoAgenticChatAvailable, duoFeaturesEnabled, projectId, namespaceId, rootNamespaceId } = await this.getProjectData(project.project.namespaceWithPath);
				this.#logger.debug(`Project ${project.project.namespaceWithPath}: duoAgenticChatAvailable = ${duoAgenticChatAvailable}, duoFeaturesEnabled = ${duoFeaturesEnabled}, projectId = ${projectId}, namespaceId = ${namespaceId}, rootNamespaceId = ${rootNamespaceId}`);
				return {
					id: projectId,
					name: project.project.name,
					namespaceWithPath: project.project.namespaceWithPath,
					remoteName: project.pointer.remote.name,
					duoAgenticChatAvailable,
					duoFeaturesEnabled,
					namespaceId,
					rootNamespaceId
				};
			}));
			return {
				type: repo.type,
				rootFsPath: repo.repository.rootFsPath,
				folderName: repo.repository.folderName,
				projects: enrichedProjects
			};
		}));
		this.#logger.debug(`Returning ${enrichedRepositories.length} enriched repositories`);
		return { repositories: enrichedRepositories };
	}
	async setSelectedProject(repositoryPath, namespaceWithPath) {
		this.#logger.debug(`Setting selected project for ${repositoryPath}: ${namespaceWithPath}`);
		await this.#selectedProjectStore.setSelectedProject(repositoryPath, namespaceWithPath);
	}
	async getSelectedProject(repositoryPath) {
		return this.#selectedProjectStore.getSelectedProject(repositoryPath);
	}
	async getProjectData(projectPath) {
		try {
			this.#logger.debug(`Getting project data for: "${projectPath}"`);
			const rootNamespacePath = projectPath.split("/")[0];
			const response = await this.#api.fetchFromApi({
				type: "graphql",
				query: gql`
          query getProjectData($projectPath: ID!, $rootNamespacePath: ID!) {
            project(fullPath: $projectPath) {
              id
              duoAgenticChatAvailable
              duoFeaturesEnabled
              namespace {
                id
                fullPath
              }
            }
            rootNamespace: namespace(fullPath: $rootNamespacePath) {
              id
            }
          }
        `,
				variables: {
					projectPath,
					rootNamespacePath
				},
				supportedSinceInstanceVersion: {
					version: "18.1.0",
					resourceName: "get project data"
				}
			});
			const projectId = response.project?.id ?? null;
			const namespaceId = response.project?.namespace?.id ?? null;
			const rootNamespaceId = response.rootNamespace?.id ?? null;
			return {
				duoAgenticChatAvailable: response.project?.duoAgenticChatAvailable ?? false,
				duoFeaturesEnabled: response.project?.duoFeaturesEnabled ?? false,
				projectId,
				namespaceId,
				rootNamespaceId
			};
		} catch (error) {
			this.#logger.error(`Error for ${projectPath}: ${String(error)}`);
			return {
				duoAgenticChatAvailable: false,
				duoFeaturesEnabled: false,
				projectId: null,
				namespaceId: null,
				rootNamespaceId: null
			};
		}
	}
	dispose() {
		this.#repositoryProviderDisposable?.dispose();
	}
	static {
		_initClass$1();
	}
});
//#endregion
//#region src/default_usage_quota_service.ts
let _initClass;
function _applyDecs(e, t, n, r, o, i) {
	var a, c, u, s, f, l, p, d = Symbol.metadata || Symbol.for("Symbol.metadata"), m = Object.defineProperty, h = Object.create, y = [h(null), h(null)], v = t.length;
	function g(t, n, r) {
		return function(o, i) {
			n && (i = o, o = e);
			for (var a = 0; a < t.length; a++) i = t[a].apply(o, r ? [i] : []);
			return r ? i : o;
		};
	}
	function b(e, t, n, r) {
		if ("function" != typeof e && (r || void 0 !== e)) throw new TypeError(t + " must " + (n || "be") + " a function" + (r ? "" : " or undefined"));
		return e;
	}
	function applyDec(e, t, n, r, o, i, u, s, f, l, p) {
		function d(e) {
			if (!p(e)) throw new TypeError("Attempted to access private element on non-instance");
		}
		var h = [].concat(t[0]), v = t[3], w = !u, D = 1 === o, S = 3 === o, j = 4 === o, E = 2 === o;
		function I(t, n, r) {
			return function(o, i) {
				return n && (i = o, o = e), r && r(o), P[t].call(o, i);
			};
		}
		if (!w) {
			var P = {}, k = [], F = S ? "get" : j || D ? "set" : "value";
			if (f ? (l || D ? P = {
				get: _setFunctionName(function() {
					return v(this);
				}, r, "get"),
				set: function(e) {
					t[4](this, e);
				}
			} : P[F] = v, l || _setFunctionName(P[F], r, E ? "" : F)) : l || (P = Object.getOwnPropertyDescriptor(e, r)), !l && !f) {
				if ((c = y[+s][r]) && 7 !== (c ^ o)) throw Error("Decorating two elements with the same name (" + P[F].name + ") is not supported yet");
				y[+s][r] = o < 3 ? 1 : o;
			}
		}
		for (var N = e, O = h.length - 1; O >= 0; O -= n ? 2 : 1) {
			var T = b(h[O], "A decorator", "be", !0), z = n ? h[O - 1] : void 0, A = {}, H = {
				kind: [
					"field",
					"accessor",
					"method",
					"getter",
					"setter",
					"class"
				][o],
				name: r,
				metadata: a,
				addInitializer: function(e, t) {
					if (e.v) throw new TypeError("attempted to call addInitializer after decoration was finished");
					b(t, "An initializer", "be", !0), i.push(t);
				}.bind(null, A)
			};
			if (w) c = T.call(z, N, H), A.v = 1, b(c, "class decorators", "return") && (N = c);
			else if (H.static = s, H.private = f, c = H.access = { has: f ? p.bind() : function(e) {
				return r in e;
			} }, j || (c.get = f ? E ? function(e) {
				return d(e), P.value;
			} : I("get", 0, d) : function(e) {
				return e[r];
			}), E || S || (c.set = f ? I("set", 0, d) : function(e, t) {
				e[r] = t;
			}), N = T.call(z, D ? {
				get: P.get,
				set: P.set
			} : P[F], H), A.v = 1, D) {
				if ("object" == typeof N && N) (c = b(N.get, "accessor.get")) && (P.get = c), (c = b(N.set, "accessor.set")) && (P.set = c), (c = b(N.init, "accessor.init")) && k.unshift(c);
				else if (void 0 !== N) throw new TypeError("accessor decorators must return an object with get, set, or init properties or undefined");
			} else b(N, (l ? "field" : "method") + " decorators", "return") && (l ? k.unshift(N) : P[F] = N);
		}
		return o < 2 && u.push(g(k, s, 1), g(i, s, 0)), l || w || (f ? D ? u.splice(-1, 0, I("get", s), I("set", s)) : u.push(E ? P[F] : b.call.bind(P[F])) : m(e, r, P)), N;
	}
	function w(e) {
		return m(e, d, {
			configurable: !0,
			enumerable: !0,
			value: a
		});
	}
	return void 0 !== i && (a = i[d]), a = h(null == a ? null : a), f = [], l = function(e) {
		e && f.push(g(e));
	}, p = function(t, r) {
		for (var i = 0; i < n.length; i++) {
			var a = n[i], c = a[1], l = 7 & c;
			if ((8 & c) == t && !l == r) {
				var p = a[2], d = !!a[3], m = 16 & c;
				applyDec(t ? e : e.prototype, a, m, d ? "#" + p : _toPropertyKey(p), l, l < 2 ? [] : t ? s = s || [] : u = u || [], f, !!t, d, r, t && d ? function(t) {
					return _checkInRHS(t) === e;
				} : o);
			}
		}
	}, p(8, 0), p(0, 0), p(8, 1), p(0, 1), l(u), l(s), c = f, v || w(e), {
		e: c,
		get c() {
			var n = [];
			return v && [w(e = applyDec(e, [t], r, e.name, 5, n)), g(n, 1)];
		}
	};
}
function _toPropertyKey(t) {
	var i = _toPrimitive(t, "string");
	return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
	if ("object" != typeof t || !t) return t;
	var e = t[Symbol.toPrimitive];
	if (void 0 !== e) {
		var i = e.call(t, r || "default");
		if ("object" != typeof i) return i;
		throw new TypeError("@@toPrimitive must return a primitive value.");
	}
	return ("string" === r ? String : Number)(t);
}
function _setFunctionName(e, t, n) {
	"symbol" == typeof t && (t = (t = t.description) ? "[" + t + "]" : "");
	try {
		Object.defineProperty(e, "name", {
			configurable: !0,
			value: n ? n + " " + t : t
		});
	} catch (e) {}
	return e;
}
function _checkInRHS(e) {
	if (Object(e) !== e) throw TypeError("right-hand side of 'in' should be an object, got " + (null !== e ? typeof e : "null"));
	return e;
}
function isUsageQuotaExceededError(error) {
	if (isFetchError(error) && error.body) return error.body.includes("USAGE_QUOTA_EXCEEDED");
	return false;
}
let _DefaultUsageQuotaSer;
(class {
	static {
		[_DefaultUsageQuotaSer, _initClass] = _applyDecs(this, [Injectable(UsageQuotaService, [GitLabApiService, Logger])], []).c;
	}
	#api;
	#logger;
	#usageQuotaExceeded = false;
	constructor(api, logger) {
		this.#api = api;
		this.#logger = withPrefix(logger, "[UsageQuotaService]");
		this.#api.onApiReconfigured(() => this.#reset());
	}
	get usageQuotaExceeded() {
		return this.#usageQuotaExceeded;
	}
	async checkUsageCreditsExceeded(signal, rootNamespaceId, workflowDefinition, projectId) {
		if (signal.aborted) return this.#usageQuotaExceeded;
		this.#logger.info(`Running credits check with rootNamespaceId: ${rootNamespaceId ?? "undefined"}, workflowDefinition: ${workflowDefinition ?? "undefined"}, projectId: ${projectId ?? "undefined"}`);
		try {
			const body = {};
			if (rootNamespaceId) body.root_namespace_id = rootNamespaceId;
			if (workflowDefinition) body.workflow_definition = workflowDefinition;
			if (projectId) body.project_id = projectId;
			this.#logger.debug(`Request body: ${JSON.stringify(body)}`);
			await retry(this.#api.fetchOperation({
				type: "rest",
				method: "POST",
				path: "/api/v4/ai/duo_workflows/direct_access",
				body,
				supportedSinceInstanceVersion: {
					resourceName: "get workflow direct access",
					version: "18.1.0"
				}
			}), {
				signal,
				shouldRetry: [
					isNotAbort,
					isNot4xxFailure,
					(error) => !isUsageQuotaExceededError(error)
				],
				onRetry: (retryCount, error) => {
					this.#logger.warn(`Failed to check usage quota. Retrying (attempt number ${retryCount})`, error);
				}
			});
			this.#usageQuotaExceeded = false;
			return false;
		} catch (error) {
			if (error instanceof AbortError) return this.#usageQuotaExceeded;
			if (error instanceof InvalidInstanceVersionError) {
				this.#logger.error("GitLab instance does not support usage quota checking.");
				return this.#usageQuotaExceeded;
			}
			if (isUsageQuotaExceededError(error)) {
				this.#logger.warn("Usage quota exceeded for duo workflows");
				this.#usageQuotaExceeded = true;
				return true;
			}
			this.#logger.error("Failed to check usage quota", error);
			this.#usageQuotaExceeded = false;
			return false;
		}
	}
	#reset() {
		this.#usageQuotaExceeded = false;
	}
	static {
		_initClass();
	}
});
//#endregion
export { AgentPlatformProjectService, AgentPlatformProjectStore, _DefaultAgentPlatform as DefaultAgentPlatformProjectService, _DefaultAgentPlatform$1 as DefaultAgentPlatformProjectStore, _DefaultUsageQuotaSer as DefaultUsageQuotaService, isUsageQuotaExceededError };

//# sourceMappingURL=node.mjs.map